<template>
  <div>
    <b-jumbotron
      bg-variant="info"
      text-variant="white"
      border-variant="dark"
      class="patient-header"
      v-bind:class="[
        VisitDay ? 'jumbotron-custom' : 'jumbotron-custom2',
        false
      ]"
    >
      <template>
        <b-row class="justify-content-md-center font-color-print">
          <b-col lg="2">
            <!-- <b-img thumbnail fluid :src="`${hnChangImage}`" alt="Image 1"></b-img> -->
            <div
              :style="{ backgroundImage: `url('${this.ptImage}')` }"
              style="background-size:cover;width:110px;height:130px; background-position:top center;"
              class="img-thumbnail img-fluid"
            ></div>
          </b-col>
          <b-col lg="10">
            <b-row>
              <b-col lg="4">
                <h4 class="font-color1 font-color-print">
                  HN {{ this.ptData && this.ptData.hn }} {{ vnChang }}
                </h4>
              </b-col>
              <b-col lg="8">
                <h4>
                  ชื่อ-สกุล
                  {{
                    this.ptData &&
                      this.ptData.pname +
                        this.ptData.fname +
                        "  " +
                        this.ptData.lname
                  }}
                </h4>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="7">
                <b-row>
                  <b-col cols="6"
                    >CID {{ this.ptData && this.ptData.cid }}</b-col
                  >
                  <b-col cols="6"
                    >วันเกิด
                    {{
                      this.ptData &&
                        this.thaiDatetimeFc.ThaiDate(this.ptData.birthday)
                    }}</b-col
                  >
                </b-row>
              </b-col>
              <b-col lg="5">
                <b-row>
                  <b-col cols="6">
                    <div
                      v-if="
                        this.$store.get('systems@BLOOD_GROUP_LAB_REPORT') == 'Y'
                      "
                    >
                      กรุ๊ปเลือด
                      <strong
                        id="BloodGroup"
                        v-if="this.BloodGroup"
                        class="cursor-pointer"
                        >{{ this.BloodGroup.lab_order_result }}</strong
                      >

                      <b-tooltip
                        target="BloodGroup"
                        variant="dark"
                        v-if="this.BloodGroup"
                      >
                        <div>{{ this.BloodGroup.lab_items_name_ref }}</div>
                        <div>
                          R.
                          {{
                            this.thaiDatetimeFc.ThaiDate(
                              this.BloodGroup.datas.report_date
                            ) +
                              " " +
                              this.BloodGroup.datas.report_time
                          }}
                          น.
                        </div>
                      </b-tooltip>

                      <strong
                        id="BloodRh"
                        v-if="this.BloodRh"
                        class="cursor-pointer"
                      >
                        : {{ this.BloodRh.lab_order_result }}</strong
                      >
                      <b-tooltip
                        target="BloodRh"
                        variant="dark"
                        v-if="this.BloodRh"
                      >
                        <div>{{ this.BloodRh.lab_items_name_ref }}</div>
                        <div>
                          R.
                          {{
                            this.thaiDatetimeFc.ThaiDate(
                              this.BloodRh.datas.report_date
                            ) +
                              " " +
                              this.BloodRh.datas.report_time
                          }}
                          น.
                        </div>
                      </b-tooltip>
                    </div>

                    <div
                      v-if="
                        this.$store.get('systems@BLOOD_GROUP_LAB_REPORT') != 'Y'
                      "
                    >
                      กรุ๊ปเลือด
                      {{
                        this.ptData &&
                          this.pjFunctionsFc.NulltoStr(this.ptData.bloodgrp) +
                            ". " +
                            this.pjFunctionsFc.NulltoStr(
                              this.ptData.bloodgroup_rh
                            )
                      }}
                    </div>
                  </b-col>
                  <b-col cols="6"
                    >อายุ {{ this.ptData && this.ptData.age_y }} ปี</b-col
                  >
                </b-row>
              </b-col>
            </b-row>

            <b-row>
              <b-col lg="12">
                ที่อยู่
                {{
                  this.ptData &&
                    this.ptData.house_number &&
                    this.pjFunctionsFc.NulltoStr(this.ptData.house_number) +
                      " หมู่ " +
                      this.pjFunctionsFc.NulltoStr(this.ptData.moopart) +
                      " ถ." +
                      this.pjFunctionsFc.NulltoStr(this.ptData.road) +
                      " " +
                      this.pjFunctionsFc.NulltoStr(this.ptData.address_part)
                }}
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                เชื้อชาติ {{ this.ptData && this.ptData.citizenship }}
              </b-col>
              <b-col>
                สัญชาติ {{ this.ptData && this.ptData.nationality }}
              </b-col>
              <b-col> ศาสนา {{ this.ptData && this.ptData.religion }} </b-col>
            </b-row>

            <b-row>
              <b-col> เบอร์โทร {{ this.ptData && this.ptData.hometel }} </b-col>
              <b-col>
                เบอร์โทรผู้ติดต่อ {{ this.ptData && this.ptData.informtel }}
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="3">
                ผู้ติดต่อ {{ this.ptData && this.ptData.Informname }}
              </b-col>
              <b-col>
                ที่อยู่ผู้ติดต่อ {{ this.ptData && this.ptData.Informaddr }}
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <h4
              class="font-color-print"
              v-bind:class="{
                'font-color-alert font-bold':
                  this.ptData && this.ptData.cc_persist_disease
              }"
            >
              โรคประจำตัว {{ this.ptData && this.ptData.cc_persist_disease }}
            </h4>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <h4
              class="font-color-print"
              v-bind:class="{
                'font-color-alert font-bold':
                  this.ptData && this.ptData.drugallergy
              }"
            >
              แพ้ยา {{ this.ptData && this.ptData.drugallergy }}
            </h4>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <h4
              class="font-color-btr font-bold font-color-print"
              v-if="this.DataBTR"
            >
              Blood transfusion reaction
            </h4>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="6" class="font-color-print">
            สิทธิการรักษา
            {{
              this.ptData &&
                this.ptData.pttype &&
                this.ptData.pttype +
                  " " +
                  this.pjFunctionsFc.NulltoStr(this.ptData.pttype_name)
            }}
          </b-col>
          <b-col lg="6" class="font-color-print">
            {{
              this.ptData &&
                this.ptData.begindate &&
                "วันเริ่ม " +
                  this.thaiDatetimeFc.ThaiDate(this.ptData.begindate) +
                  " | สิ้นสุด " +
                  this.thaiDatetimeFc.ThaiDate(this.ptData.expiredate)
            }}
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            {{
              this.ptData &&
                this.ptData.hospmain &&
                "สถานพยาบาลหลัก " +
                  this.ptData.hospmain +
                  " " +
                  this.ptData.hospmain_name
            }}
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            {{
              this.ptData &&
                this.ptData.hospsub &&
                "สถานพยาบาลรอง " +
                  this.ptData.hospsub +
                  " " +
                  this.ptData.hospsub_name
            }}
          </b-col>
        </b-row>

        <hr class="hr-magin d-print-none" />

        <b-row class="d-print-none">
          <b-col lg="12" v-if="this.ptData">
            <b-img
              v-if="this.ptData"
              thumbnail
              rounded="circle"
              alt="เช็คสิทธิ (สปสช.)"
              title="เช็คสิทธิ (สปสช.)"
              width="50"
              class="icon-css cursor-pointer margin-right8px"
              style="background-color:#ffffff;padding:2px;"
              v-bind:src="imgNHSOIcon"
              v-b-modal.modal-nhso-rights-data
            ></b-img>

            <b-img
              v-if="this.ptData"
              thumbnail
              rounded="circle"
              alt="ตรวจสอบการเดินทางเข้าเมือง"
              title="ตรวจสอบการเดินทางเข้าเมือง"
              width="50"
              class="icon-css cursor-pointer margin-right8px"
              style="background-color:#ffffff;padding:2px;"
              v-bind:src="imgPlaneIcon"
              v-b-modal.modal-moph-immigration-data
            ></b-img>

            <b-img
              v-if="visitAN"
              thumbnail
              rounded="circle"
              :alt="'ประวัติ Admit AN : ' + visitAN"
              :title="'ประวัติ Admit AN : ' + visitAN"
              width="50"
              class="icon-css cursor-pointer margin-right8px"
              style="background-color:#ffffff;padding:2px;"
              v-bind:src="imgAdmitIcon"
              @click="selectAN(visitAN)"
            ></b-img>

            <b-img
              v-if="visitAN"
              thumbnail
              rounded="circle"
              :alt="'ตรวจสอบสิทธิ AN : ' + visitAN"
              :title="'ตรวจสอบสิทธิ AN : ' + visitAN"
              width="50"
              class="icon-css cursor-pointer margin-right8px"
              style="padding:2px;"
              v-bind:class="[
                AdmitRightsCenterHeadData
                  ? 'admit-pttype-success'
                  : 'admit-pttype-default',
                false
              ]"
              v-bind:src="imgAdmitPttypeIcon"
              v-b-modal.modal-admit-rights-data
            ></b-img>

            <b-img
              v-if="this.ptData"
              thumbnail
              rounded="circle"
              alt="ข้อมูล Ever Refer"
              title="ข้อมูล Ever Refer"
              width="50"
              class="icon-css cursor-pointer margin-right8px"
              style="background-color:#ffffff;padding:2px;"
              v-bind:src="imgReferIcon"
              v-b-modal.modal-ever-immigration-data
            ></b-img>

            <b-img
              v-if="this.ptData"
              thumbnail
              rounded="circle"
              alt="Vaccine covid"
              title="Vaccine covid"
              width="50"
              class="icon-css cursor-pointer margin-right8px"
              style="background-color:#ffffff;padding:2px;"
              v-bind:src="imgVaccineCovidIcon"
              v-on:click="openVaccineCovid"  
            ></b-img>

            <b-img
              v-if="this.ptData"
              thumbnail
              rounded="circle"
              alt="iChart"
              title="iChart"
              width="50"
              class="icon-css cursor-pointer margin-right8px"
              style="background-color:#ffffff;padding:2px;"
              v-bind:src="imgIChartIcon"
              v-on:click="openIChart"  
            ></b-img>

          </b-col>
        </b-row>

        <b-row v-if="this.ptData" v-show="false">
          <b-col lg="12">
            <b-modal
              id="modal-nhso-rights-data"
              title="ตรวจสอบสิทธิการรักษาของผู้ป่วย (สปสช.)"
              size="xl"
              button-size="sm"
              hide-footer
              :no-close-on-backdrop="true"
              :close-on-esc="true"
            >
              <EmrCheckNHSO v-bind:my-cid="this.ptData.cid"></EmrCheckNHSO>
            </b-modal>
            <b-button
              size="sm"
              variant="info"
              v-b-modal.modal-nhso-rights-data
              class="d-print-none"
              >เช็คสิทธิ (สปสช.)</b-button
            >
          </b-col>

          <b-col lg="12">
            <b-modal
              id="modal-moph-immigration-data"
              title="ตรวจสอบการเดินทางเข้าประเทศ"
              size="xl"
              button-size="sm"
              hide-footer
              :no-close-on-backdrop="true"
              :close-on-esc="true"
            >
              <EmrCheckMophImmigration
                v-bind:my-cid="this.ptData.cid"
                v-bind:my-nationality="this.ptData.nationality"
                v-bind:my-passportno="this.ptData.passport_no"
              ></EmrCheckMophImmigration>
            </b-modal>
          </b-col>

          <b-col lg="12">
            <b-modal
              id="modal-ever-immigration-data"
              title="ข้อมูล Ever Refer"
              size="xl"
              button-size="sm"
              hide-footer
              :no-close-on-backdrop="true"
              :close-on-esc="true"
            >
              <EmrCheckRefer v-bind:my-cid="this.ptData.cid"></EmrCheckRefer>
            </b-modal>
          </b-col>
        </b-row>

        <b-row v-for="item in MDRData" v-bind:key="item.id">
          <b-col>
            <h4
              v-bind:class="{
                'font-color-alert font-bold font-color-print': item.hn
              }"
            >
              MDR :
              {{
                item.datas.mdr_alert_type +
                  " ( " +
                  thaiDatetimeFc.ThaiDateTimeNonSec(item.report_datetime) +
                  " )"
              }}
            </h4>
          </b-col>
        </b-row>
      </template>

      <hr class="hr-magin" />

      <template>
        <b-row>
          <div v-if="this.$store.get('systems@anEMR')">
            <b-modal
              id="modal-admit-data"
              title="ประวัติ Admit"
              size="xl"
              hide-footer
              button-size="sm"
              :no-close-on-backdrop="true"
              :close-on-esc="true"
            >
              <EmrAdmitData
                v-bind:my-vn="this.ptVN"
                v-bind:my-hn="this.ptHN"
                v-bind:my-an="this.$store.get('systems@anEMR')"
              ></EmrAdmitData>
            </b-modal>
          </div>
          <b-col lg="6" v-if="visitAN" class="margin-bottom-lg" v-show="false">
            <b-button variant="danger" size="sm" @click="selectAN(visitAN)"
              >ประวัติ Admit : {{ visitAN }}</b-button
            >
          </b-col>
          <b-col lg="6" v-if="visitAN" class="margin-bottom-lg" v-show="false">
            <b-modal
              id="modal-admit-rights-data"
              title="IPD Rights (สิทธิการรักษาผู้ป่วยใน)"
              size="xl"
              button-size="sm"
              hide-footer
              :no-close-on-backdrop="true"
              :close-on-esc="true"
            >
              <EmrAdmitRightsData
                v-bind:my-vn="this.ptVN"
                v-bind:my-hn="this.ptHN"
                v-bind:my-an="this.visitAN"
              ></EmrAdmitRightsData>
            </b-modal>
            <b-button
              size="sm"
              :variant="(AdmitRightsCenterHeadData && 'success') || 'secondary'"
              v-b-modal.modal-admit-rights-data
              >ตรวจสอบสิทธิ AN : {{ visitAN }}</b-button
            >
          </b-col>
        </b-row>
      </template>
    </b-jumbotron>
  </div>
</template>

<script >
import { Component, Vue, Prop } from "vue-property-decorator";
import feather from "vue-icon";
import store from "@/store/store";
import PatientData from "@/models/patientEMRs/PatientData";
import PatientImage from "@/models/patientEMRs/PatientImage";
import { call } from "vuex-pathify";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";
import EmrAdmitData from "@/components/PatientEMR/EmrAdmitData";
import EmrAdmitRightsData from "@/components/PatientEMR/EmrAdmitRightsData";
import EmrCheckNHSO from "@/components/PatientEMR/EmrCheckNHSO";
import EmrCheckMophImmigration from "@/components/PatientEMR/EmrCheckMophImmigration";
import EmrCheckRefer from "@/components/PatientEMR/EmrCheckRefer";

import PatientVisit from "@/models/patientEMRs/PatientVisit";
import PatientAdmitRightsCenterHead from "@/models/patientEMRs/PatientAdmitRightsCenterHead";
import PatientAdmitRightsCenterList from "@/models/patientEMRs/PatientAdmitRightsCenterList";
import PatientAdmitRightsCenterListL1 from "@/models/patientEMRs/PatientAdmitRightsCenterListL1";
import PatientAdmitRightsCenterListL2 from "@/models/patientEMRs/PatientAdmitRightsCenterListL2";
import PatientMDRData from "@/models/patientEMRs/PatientMDRData";
import LabBtrData from "@/models/patientEMRs/LabBtrData";

import PatientLabBloodGroup from "@/models/patientEMRs/PatientLabBloodGroup";

const NHSOIcon = require("@/images/unnamed.png");
const AdmitIcon = require("@/images/bed21-512.png");
const AdmitPttypeIcon = require("@/images/hotel-512.png");
const PlaneIcon = require("@/images/plane512.png");
const ReferIcon = require("@/images/Refer-272-512.png");
const VaccineCovidIcon = require("@/images/vaccineCovid.jpg");
const IChartIcon = require("@/images/logoIChart144.png");


Vue.component("EmrAdmitData", EmrAdmitData);
Vue.component("EmrAdmitRightsData", EmrAdmitRightsData);
Vue.component("EmrCheckNHSO", EmrCheckNHSO);
Vue.component("EmrCheckMophImmigration", EmrCheckMophImmigration);
Vue.component("EmrCheckRefer", EmrCheckRefer);

Vue.use(feather, "v-icon");

@Component({
  data() {
    return {
      ptImage: "",
      ptData: null,
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      ptHN: "",
      ptVN: "",
      visitAN: "",
      AdmitRightsCenterHeadData: null,
      HNloadSTD: "",
      VisitDay: true,
      MDRData: null,
      DataBTR: null,
      BloodGroup: null,
      BloodRh: null,
      imgNHSOIcon: NHSOIcon,
      imgAdmitIcon: AdmitIcon,
      imgAdmitPttypeIcon: AdmitPttypeIcon,
      imgPlaneIcon: PlaneIcon,
      imgReferIcon: ReferIcon,
      imgVaccineCovidIcon : VaccineCovidIcon,
      imgIChartIcon: IChartIcon
    };
  },
  props: ["MyVn", "MyHn"],
  component: {
    PatientData,
    PatientImage,
    thaiDatetime,
    PatientVisit,
    PatientAdmitRightsCenterHead,
    PatientAdmitRightsCenterList,
    PatientAdmitRightsCenterListL1,
    PatientAdmitRightsCenterListL2,
    PatientMDRData,
    LabBtrData,
    PatientLabBloodGroup
  },
  created() {
    this.thaiDatetimeFc = thaiDatetime.methods;
    this.pjFunctionsFc = pjFunctions.methods;
  },
  watch: {
    // whenever question changes, this function will run
    // ptHN: function () {
    //   console.log('wwwwwwwwww')
    // }
    MyVn: function() {
      this.vnChang;
    },
    MyHn: function() {
      this.vnChang;
    },
    ptVN: function() {
      this.getVisitData(this.ptVN);
      this.setQueryBTR(this.ptHN);
    }
  },
  computed: {
    vnChang: function() {
      this.ptHN = this.MyHn;
      this.ptVN = this.MyVn;
      this.hnChang(this.ptHN);
      // this.setQueryBTR(this.ptHN);
    }
  },
  methods: {
    hnChang(hn) {
      if ((!this.ptData || this.HNloadSTD != hn) && hn != "") {
        this.HNloadSTD = hn;

        if (
          PatientData.query()
            .where("hn", hn)
            .get()[0]
        ) {
          this.ptHN = hn;

          let ptData2 = PatientData.query()
            .where(record => record.datas.hn == hn)
            .get();
          if (ptData2[0].datas.hn != "") {
            this.ptData = ptData2[0].datas;
          } else {
            this.ptData = null;
          }

          let ptMdrData = PatientMDRData.query()
            .where(record => record.hn == hn)
            .get();

          if (PatientMDRData) {
            this.MDRData = ptMdrData;
          } else {
            this.MDRData = null;
          }

          let BloodGroupCk = PatientLabBloodGroup.query()
            .where(record => record.hn == hn)
            .where(record => record.items_type == "blood_group")
            .get();

          if (BloodGroupCk) {
            this.BloodGroup = BloodGroupCk[0];
          } else {
            this.BloodGroup = null;
          }

          let BloodRhCk = PatientLabBloodGroup.query()
            .where(record => record.hn == hn)
            .where(record => record.items_type == "blood_rh")
            .get();

          if (BloodRhCk) {
            this.BloodRh = BloodRhCk[0];
          } else {
            this.BloodRh = null;
          }
        } else {
          this.ptData = null;
        }

        if (
          PatientImage.query()
            .where("id", hn)
            .get()[0]
        ) {
          let ptImage2 = PatientImage.query()
            .where(record => record.datas.hn == hn)
            .get();
          if (ptImage2[0].datas.patient_image != "") {
            this.ptImage =
              "data:image/png;base64," + ptImage2[0].datas.patient_image;
          } else {
            this.ptImage = "";
          }
        } else {
          this.ptImage = "";
        }
      }
    },
    getVisitData(vn) {
      let DataObj = PatientVisit.query()
        .where(record => record.datas.vn == vn)
        .where(record => record.datas.an != "")
        .get();

      if (DataObj.length > 0) {
        this.visitAN = DataObj[0].datas.an;

        // let dnow = new Date();
        let DateNow = this.thaiDatetimeFc.DateNow();

        if (DataObj[0].datas.vstdate != DateNow) {
          this.VisitDay = false;
        } else {
          this.VisitDay = true;
        }

        this.setAdmitRights(DataObj[0].datas.an, DataObj[0].datas.hn);
      } else {
        this.visitAN = "";
      }
    },
    setAdmitRights(an, hn) {
      let data = [];
      let val = null;
      let DataLoadObj = this;

      if (hn != "" && an != "" && an != null && an != "null") {
        // #### Admit Rights Center Data Load ####
        this.axios
          .post(this.$store.get("systems@UrlApi") + "AdmitRightsCenterData", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            an: an,
            hn: hn
          })
          .then(function(response) {
            DataLoadObj.output = response.data;
            if (DataLoadObj.output.status === true) {
              PatientAdmitRightsCenterHead.delete({
                where(record) {
                  return record.an == an;
                }
              });

              data = [];
              for (val of DataLoadObj.output.result.RightsCenterData
                .emr_ipd_rights_head) {
                data.push({
                  id: val.an + val.user_edit + val.emr_ipd_rights_head_status,
                  an: val.an,
                  hn: val.hn,
                  emr_ipd_rights_head_status: val.emr_ipd_rights_head_status,
                  datas: val
                });
              }

              PatientAdmitRightsCenterHead.insertOrUpdate({
                data
              });
            } else {
              if (DataLoadObj.output.ErrorMessage === "Data Not Found") {
                PatientAdmitRightsCenterHead.delete({
                  where(record) {
                    return record.an == an;
                  }
                });
              }
            }
          })
          .catch(function(error) {
            DataLoadObj.output = error;
            console.log("AdmitRightsCenterData : " + DataLoadObj.output);
          })
          .finally(function() {
            DataLoadObj.getAdmitRights(an, hn, "RightsHead");
          });
      }
    },
    getAdmitRights(an, hn, action) {
      let DataObj = null;

      if (hn != "" && an != "" && action == "RightsHead") {
        /** get Rights Head */
        DataObj = null;
        DataObj = PatientAdmitRightsCenterHead.query()
          .where(record => record.hn == hn)
          .where(record => record.an == an)
          .where(record => record.emr_ipd_rights_head_status == "Y")
          .get();

        if (DataObj.length > 0) {
          this.AdmitRightsCenterHeadData = DataObj;
        } else {
          this.AdmitRightsCenterHeadData = null;
        }
      }
    },
    setQueryBTR(hn) {
      let data = [];

      /** LabBtrQueryData */
      let DataObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "LabBtrQueryData", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn
        })
        .then(function(response) {
          DataObj.output = response.data;
          if (DataObj.output.status === true) {
            LabBtrData.delete({
              where(record) {
                return record.hn == hn;
              }
            });

            data = [];
            for (var val of DataObj.output.result) {
              data.push({
                id: val.btrMain.btr_id,
                btr_id: val.btrMain.btr_id,
                hn: val.btrMain.hn,
                vn: val.btrMain.vn,
                an: val.btrMain.an,
                ptName:
                  val.btrMain.pname +
                  val.btrMain.fname +
                  " " +
                  val.btrMain.lname,
                transfusion_start_date: val.btrMain.transfusion_start_date,
                transfusion_start_time: val.btrMain.symptom_start_date,
                symptom_start_date: val.btrMain.symptom_start_date,
                symptom_start_time: val.btrMain.symptom_start_time,
                lab_receive_status: val.btrMain.lab_receive_status,
                lab_cross_matching_status:
                  val.btrMain.lab_cross_matching_status,
                btr_status: val.btrMain.btr_status,
                datas: val,
                list_orderby: val.btrMain.list_orderby
              });
            }

            LabBtrData.insertOrUpdate({
              data
            });
          } else {
            if (DataObj.output.ErrorMessage === "Data Not Found") {
              LabBtrData.delete({
                where(record) {
                  return record.hn == hn;
                }
              });
            }
          }
        })
        .catch(function(error) {
          DataObj.output = error;
          console.log("LabBtrData : " + DataObj.output);
        })
        .finally(function() {
          DataObj.getQueryBTR(hn);
        });
    },
    getQueryBTR(hn) {
      let ScrObj = null;

      ScrObj = LabBtrData.query()
        .where(record => record.hn == hn)
        .where(record => record.btr_status == "Y")
        .orderBy("list_orderby")
        .get();

      if (ScrObj.length > 0) {
        this.DataBTR = ScrObj;
      } else {
        this.DataBTR = null;
      }
    },
    selectAN(an) {
      if (this.$store.get("systems@PageWidth") <= 991) {
        // this.$root.$emit("bv::toggle::collapse", "nav-collapse-visit");
        this.$root.$emit("bv::toggle::collapse", "nav-collapse-visit");
      }

      store.set("systems@anEMR", an);
      setTimeout(() => {
        // v-b-modal.modal-admit-data
        this.$bvModal.show("modal-admit-data");
      }, 500);
    },
    openVaccineCovid() {
      // let routeData = this.$router.resolve({name: 'routeName', query: {data: "someData"}});
      window.open(this.$store.get("systems@VACCINE_COVID")+'?hn='+this.ptHN+'&vn='+this.ptVN+'&an='+this.visitAN+'&cid='+this.ptData.cid, 'VACCINE_COVID');

    },

    openIChart() {
      const userId = this.$store.get('systems@LoginData').UserId;
      window.open('https://ichart.smpkhos.go.th/?hn='+this.ptHN+'&user='+userId+'&vn='+this.ptVN+'&an='+this.visitAN, 'ICHART');

    }

  }
})
export default class EmrPatientData extends Vue {}
</script>

<style lang="scss">
.alert {
  margin-bottom: 0px !important;
}
</style>

